import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CtaBand({
  title = "Ready to Make What’s Next Possible?",
  subtitle = "Get expert guidance on your cloud strategy, migration or modernization journey.",
}) {
  return (
    <section className="bg-cbmist">
      <div className="container-cb py-14">
        <div className="flex flex-col items-start justify-between gap-6 rounded-3xl border border-border bg-gradient-to-br from-white to-cbblue-soft/50 p-8 shadow-card lg:flex-row lg:items-center lg:p-10">
          <div className="max-w-2xl">
            <h2 className="font-display text-2xl font-extrabold text-cbink sm:text-[32px]">{title}</h2>
            <p className="mt-3 text-[16px] leading-relaxed text-cbslate">{subtitle}</p>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <Link to="/book" className="btn-primary" data-testid="cta-assessment">
              Start a Cloud Assessment <ArrowRight size={16} />
            </Link>
            <Link to="/book" className="btn-secondary" data-testid="cta-architect">
              Talk to an Architect
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
